import React, { useState, useMemo } from "react";
import { Modal, Select } from "antd";
import { filmStore } from "@/store/film";
import { notification } from "antd";

import FilmVideoFile from "@/components/film/FilmVideoFile";

interface Props {
  voiceover: any;
  type?: string;

  close: () => void;
  save: (data:any, type?: string) => void;
  updateSerie: (data:any) => void
}

function ModalVoiceover({ close, save, updateSerie, voiceover, type }: Props) {
  const [data, setData] = useState( voiceover ? voiceover : {});
  const dataOld = Object.assign({}, data)

  const handleOk = () => {
    try {
      if(data.voiceoverName) {
        data.name = data.voiceoverName;
      }

      data.has_internal_ads = data.has_internal_ads ? true : false;
      data.isNew = true;
      data.old = dataOld;

      if(!data.isEdit) {
        if(!data.video_file) {
          notification.warning({
            message: 'Необходимо выбрать файл',
          });
          return
        }
      }

      if (data?.id && type === 'serie') {
        save(data, 'edit');
        filmStore.addVoiceoversToEdit(data)
        close()
        return;
      }

      if(type === 'serie') {
        save(data);
      } else {
        if(voiceover && voiceover.voiceover_id) {
          // Второй аргумент — сам элемент списка: правка не должна задевать соседние
          filmStore.editVoiceOver(data, voiceover)
        } else {
         filmStore.addToVoiceOvers(data); 
        }
      }

      close();

    } catch (err) {
      console.error(err);
    }
  };

  const handleUpdate = (key, value) => {
    setData((item) => ({
      ...item,
      isEdit: voiceover?.voiceover_id ? true : false,
      [key]: value,
    }));
  };

  const isEdit = useMemo(() => {
    if(voiceover?.voiceover_id) {
      return true
    }

    if(voiceover?.id) {
      return true
    }

    return false;
  }, [])

  const modalTitle = useMemo(() => {
    if(voiceover?.voiceover_id || voiceover?.id) {
      return 'Редактирование озвучки'
    }

    return 'Новая озвучка'
  }, [])

  return (
    <Modal
      title={modalTitle}
      closable={{ "aria-label": "Custom Close Button" }}
      open={true}
      onOk={handleOk}
      onCancel={close}
      okText="Сохранить"
      cancelText="Отмена"
      
    >
      <FilmVideoFile update={handleUpdate} data={data} isEdit={isEdit} />
    </Modal>
  );
}

export default ModalVoiceover;
